export function safeOpenJarabot() {
	if (typeof window === 'undefined') return;

	if (window.$chatwoot?.toggle) {
		window.$chatwoot.toggle('open');
		return;
	}

	const onReady = () => {
		window.removeEventListener('chatwoot:ready', onReady);
		window.$chatwoot?.toggle?.('open');
	};
	window.addEventListener('chatwoot:ready', onReady, { once: true });
}
